import React, { useEffect, useState } from "react";

import CardLeftRight from "./cardleftright";
import { dataListsType } from "./featured-posts";
import { DataLists } from "../dataLists/DataLists";

const LatestPosts: React.FC = () => {
  const [latestPostsData, setLatestPostsData] = useState<dataListsType[]>([]);

  const getLatestPostsData = () => {
    // const data = [...DataLists].slice(-6).sort(() => 0.5 - Math.random());
    const randomData = [...DataLists]
      .slice(-16)
      .sort(() => 0.5 - Math.random());
    const data = randomData.slice(0, 6);
    setLatestPostsData(data);
  };

  useEffect(() => {
    getLatestPostsData();
  }, []);

  return (
    <div className="w-full flex justify-center py-[50px] bg-[#f6f7f8]">
      <div className="w-full max-w-[1116px] px-8 flex justify-between">
        <div className="w-full flex flex-col">
          <div className="mb-8 border-b-[1px]">
            <h5 className="text-sm font-semibold pt-0 pb-2 tracking-widest">
              LATEST POSTS
            </h5>
            <span className="block w-14 h-[3px] bg-black"></span>
          </div>
          <div className="w-full flex flex-col gap-y-10 px-6">
            <CardLeftRight props={latestPostsData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestPosts;
